import React, { useState } from "react";
import { clockTimingInterface } from "../../../../API/request/clockTimingInterface";
import { EndDay, StopBreak, StopWork } from "../../../../API/response/worktimeclock";
import {DynamikModal, UniButton} from "../../../../../../@WUM/core/Elements";

interface EndWorkButtonProps {
    onSuccess?: (result: clockTimingInterface) => void;
}

const EndWorkingDayButton = ({ onSuccess }: EndWorkButtonProps) => {
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);

    const handleShow = () => setShowModal(true);
    const handleClose = () => setShowModal(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);

        try {
            await StopBreak();
            await StopWork();
            const result = await EndDay();

            if (result) {
                localStorage.setItem("workStart", new Date().toISOString());
                onSuccess?.(result);
            }
        } finally {
            setLoading(false);
            handleClose();
        }
    };

    return (
        <>
            <UniButton
                variant="danger"
                onClick={handleShow}
                class="d-flex align-items-center gap-2"
            >
                💤 Arbeitstag beenden
            </UniButton>

            <DynamikModal
                title="Arbeitstag wirklich beenden?"
                body={
                    <div className="text-start">
                        <p>
                            Mit dem Beenden des Arbeitstages werden alle Arbeits- und Pausenzeiten dieses Tages gespeichert.
                        </p>
                        <p className="fw-bold text-danger">
                            Eine Wiederaufnahme der Arbeit für diesen Tag ist anschließend nicht mehr möglich.
                        </p>
                        <p>Möchten Sie wirklich fortfahren?</p>
                    </div>
                }
                openButtonLabel=""
                variantSaveButton="danger"
                saveButtonLabel="💤 Ja, Arbeitstag beenden"
                closeButtonLabel="Abbrechen"
                handleShow={handleShow}
                handleClose={handleClose}
                handlesubmit={handleSubmit}
                show={showModal}
                setShow={setShowModal}
                saveDisabled={loading}
                indiButton
            />
        </>
    );
};

export default EndWorkingDayButton;
